module.exports = __webpack_public_path__ + "assets/d7a3d80b44b51d40abf55405fd66759b.png";